import React, { useEffect } from "react";
import AntdModal from "../../../components/common/AntdModal";
import { useStaffMinutesStore } from "../../../config/stores";
import { Form, DatePicker, Upload, Button, Space, message } from "antd";
import AppInput from "../../../components/common/AppInput";
import AppButton from "../../../components/common/AppButton";
import { UploadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { isEmpty } from "lodash";

const StaffMinutesForm = () => {
  const staffMinutesStore = useStaffMinutesStore();
  const {
    showCreateStaffMinute,
    creating,
    creatingStaffMinute,
    staffMinuteToEdit,
    setCreatingStaffMinute,
  } = staffMinutesStore;
  const [form] = Form.useForm();

  useEffect(() => {
    if (!isEmpty(staffMinuteToEdit) && !creating) {
      form.setFieldsValue({
        ...staffMinuteToEdit,
        date: staffMinuteToEdit.date ? dayjs(staffMinuteToEdit.date) : null,
      });
    } else {
      // form.resetFields();
    }
  }, [staffMinuteToEdit, creatingStaffMinute, form]);

  const onSubmit = () => {
    form
      .validateFields()
      .then(async (values) => {
        const formData = {
          ...values,
          date: values.date ? values.date.format("YYYY-MM-DD") : undefined,
        };
        if (
          values.file &&
          Array.isArray(values.file) &&
          values.file.length > 0
        ) {
          formData.file = values.file[0].originFileObj;
        }
        if (creating) {
          staffMinutesStore.createStaffMinute(formData);
        } else {
          staffMinutesStore.updateStaffMinute(staffMinuteToEdit.id, formData);
        }
      })
      .catch((err) => {
        message.error("Please fill all fields correctly");
        console.log(err);
      });
  };

  return (
    <AntdModal
      open={showCreateStaffMinute}
      title={creating ? "Upload Staff Minutes" : "Update Staff Minutes"}
      footer={[
        <Space>
          <AppButton
            htmlType="submit"
            text={creating ? "Create Staff Minutes" : "Update Staff Minutes"}
            loading={
              staffMinutesStore.creatingStaffMinute ||
              staffMinutesStore.updatingStaffMinute
            }
            type="primary"
            onClick={onSubmit}
          />
          <AppButton
            danger
            type="default"
            text="Cancel"
            onClick={() => {
              form.resetFields();
              setCreatingStaffMinute(false, false, null);
            }}
          />
        </Space>,
      ]}
      closeModal={() => setCreatingStaffMinute(false, false, null)}
    >
      <Form layout="vertical" form={form} initialValues={{ date: dayjs() }}>
        <Form.Item
          label="Date"
          name="date"
          rules={[{ required: true, message: "Date is required" }]}
        >
          <DatePicker style={{ width: "100%" }} />
        </Form.Item>
        <AppInput
          name="type"
          label="Type"
          type="select"
          options={[
            {
              label: "Staff Meeting",
              value: "Staff Meeting",
            },
            {
              label: "Board Meeting",
              value: "Board Meeting",
            },
            {
              label: "Management Meeting",
              value: "Management Meeting",
            },
            {
              label: "Other",
              value: "Other",
            },
          ]}
          rules={[{ required: "Type is required" }]}
        />
        <AppInput
          name="venue"
          label="Venue"
          rules={[{ required: "Venue is required" }]}
        />
        <Form.Item
          label="Minutes File (PDF)"
          name="file"
          valuePropName="fileList"
          getValueFromEvent={(e) => (Array.isArray(e) ? e : e && e.fileList)}
          rules={
            creating ? [{ required: true, message: "File is required" }] : []
          }
        >
          <Upload
            beforeUpload={() => false}
            accept="application/pdf"
            maxCount={1}
            showUploadList={{ showRemove: true }}
          >
            <Button icon={<UploadOutlined />}>Select PDF</Button>
          </Upload>
        </Form.Item>
      </Form>
    </AntdModal>
  );
};

export default StaffMinutesForm;
